import { SQLGeneratedProcess } from "@avenueops/shared-types";
import { getClientTime } from "utils/time";

interface Props {
  row: SQLGeneratedProcess;
}

export default function WorkflowTitle({ row }: Props) {
  return <span>{row.workflowTitle}</span>;
}
